<div class="bg-white p-3 mt-1">
  <div class="row mb-3">
    <div class="col-lg-12">
      <div class="photo-upload-title">Upload Photo</div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 col-xl-4">
      <div class="uploaded-files mb-3">
        <div class="upload-sec" appFieldPermission="upload_photo">
          <div class="block drop-container" [hidden]="isImageUploaded" #file (ngxf-drop)="uploadFile($event)"
            (ngxf-select)="uploadFile($event)" drop-class="drop" [ngxf-validate]="{ size: { min: 5 } }" multiple >
            <i class="fa fa-cloud-upload mb-2" aria-hidden="true" ></i>
            <p>Drag and Drop or <a href="javascript:;">Browse</a></p>
            <p class="mt-5">Max file size 3MB <br> Supported formats: JPG, JPEG, PNG, JFIF</p>
          </div>
          <div [hidden]="!isImageUploaded">
            <img class="upload-image-preview" [src]="imgUrl2" alt="Youth Image">
          </div>
        </div>
      </div>
      <div class="progress-wrap">
        <div class="d-flex justify-content-between mb-1">
          <h6>{{fileName}}</h6>
          <span [hidden]="isEditMode" >{{fileSize}}/3MB</span>
          <a href="javascript:;" class="progress-close" (click)="clearImage()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </a>
        </div>
        <div class="progress">
          <div class="progress-bar bg-info" role="progressbar" [style.width.%]="fileSizeRaw / 3072 * 100"
            [attr.aria-valuenow]="fileSizeRaw" aria-valuemin="0" aria-valuemax="3072"></div>
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-xl-8">
      <div class="upload-wrap dd-overflow-inherit" [formGroup]="documentUploadForm">
        <div class="uploaded-form">
          <div class="p-fluid p-formgrid row">
            <!-- <div class="p-field col-lg-3 col-sm-4 col-md-12 col-12">
              <label for="fname" class="referral-form-labels">
                Photo Type
                <span class="requiredfield text-danger">*</span>
                <i class="fa fa-question-circle ml-1" aria-hidden="true"></i>
              </label>
              <input type="text" pInputText placeholder="[current user]" formControlName="photoType" />
              <p-dropdown [options]="typeList" inputId="role" placeholder="Please Select" styleClass="w-100"
                optionLabel="label" optionValue="value" filter="true" formControlName="photoType" (onChange)=""
                ariaFilterLabel="null">
              </p-dropdown>
            </div> -->
            <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" appFieldPermission="entered_date">
              <label for="fname" class="referral-form-labels">
                Entered Date
                <span class="requiredfield text-danger">*</span>
              </label>
              <p-calendar type="date" formControlName="entered_date" placeholder="[current date]" appFieldPermission="entered_date"
                [selectOtherMonths]="true" [showIcon]="true" [showOnFocus]="false"></p-calendar>
            </div>
            <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" appFieldPermission="photo_date">
              <div>
                <label for="fname" class="referral-form-labels">
                  Photo Date
                  <span class="requiredfield text-danger">*</span>
                </label>
                <p-calendar type="date" formControlName="photo_date" placeholder="MM/DD/YYYY" [selectOtherMonths]="true" appFieldPermission="photo_date"
                  [showIcon]="true" [maxDate]="maxDate" [showOnFocus]="false"></p-calendar>
              </div>

            </div>
            <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" appFieldPermission="type_code">
              <label for="fname" class="referral-form-labels" >
                Type
                <span class="requiredfield text-danger">*</span>
              </label>
              <p-dropdown [options]="photoTypeList" inputId="role"  placeholder="Please Select"
              styleClass="w-100" optionLabel="label" optionValue="value" [filter]="true" formControlName="type_code" appFieldPermission="type_code"
              (onChange)="changeTypeValue($event)" ariaFilterLabel="null" [showClear]="true">
              <ng-template let-item pTemplate="selectedItem">
                <div pTooltip="{{item?.label}}" tooltipPosition="top" class="text-truncate"> {{ item?.label }}</div>
              </ng-template>
              <ng-template let-object pTemplate="item">
                {{ object.label }}
              </ng-template>
              </p-dropdown>
            </div>

          </div>
          <div class="p-fluid p-formgrid row">

            <div class="p-field col-lg-6 col-sm-4 col-md-12 col-12" appFieldPermission="entered_by_worker_name">
              <div>
                <label for="fname" class="referral-form-labels">
                  Entered By
                  <span class="requiredfield text-danger">*</span>
                </label>
                <input type="text" pInputText placeholder="[current user]" formControlName="entered_by_worker_name" appFieldPermission="entered_by_worker_name"/>
              </div>
            </div>
            <div class="p-field col-lg-6 col-sm-4 col-md-12 col-12" *ngIf="!hidePrimaryFlag">
              <div class="g-checkbox mtc-2">
                <input type="checkbox" formControlName="primary_flag" appFieldPermission="primary_flag" id="" class="packetsub-cls" />
                <label for="" aria-labelledby="" class="pl-2 mt-0 mb-0">Primary Photo</label>
              </div>
            </div>

          </div>
          <div  class="p-fluid p-formgrid row">
            <div class="p-field col-lg-6 col-sm-4 col-md-12 col-12"  appFieldPermission="description">
              <label for="fname" class="referral-form-labels">
                Description
                <span class="requiredfield text-danger">*</span>
              </label>
              <p-dropdown [options]="descriptionList" inputId="description" placeholder="Please Select"
              styleClass="w-100" optionLabel="label" optionValue="value" [filter]="true" formControlName="description" appFieldPermission="description"
              (onChange)="changeDescriptionValue($event)" ariaFilterLabel="null" [showClear]="true">
              <ng-template let-item pTemplate="selectedItem">
                <div pTooltip="{{item?.value}}" tooltipPosition="top" class="text-truncate"> {{ item?.value }}</div>
              </ng-template>
              <ng-template let-object pTemplate="item">
                {{ object.value }}
              </ng-template>
            </p-dropdown>

            </div>
            <div class="p-field col-lg-6 col-sm-4 col-md-12 col-12" [hidden]="!showDescription" appFieldPermission="moreDescription">
              <label for="fname" class="referral-form-labels">
                Other
                <span class="requiredfield text-danger">*</span>
              </label>
              <input type="text" pInputText placeholder="Other" formControlName="moreDescription" appFieldPermission="moreDescription"/>
              <!-- <textarea class="form-control" formControlName="moreDescription" placeholder="Others"></textarea> -->
              <div *ngIf="moreDescription?.errors?.maxlength">
                <div class="p-error block mt-1">Description cannot be more than 100 characters.</div>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <button class="pull-right mb-2 btn btn-primary btncommon" [disabled]="documentUploadForm.invalid" (click)="sendDocument()"
            appFieldPermission="submit">Save</button>
            <button (click)="resetValue()"
              class="pull-right mb-2 mr-2 btn btn-white border border-1 border-primary text-primary btncancel" appFieldPermission="cancel">
              {{ isButtonShowHide ? 'Cancel Changes' : 'Cancel' }}
            </button>
            <button class="pull-right mb-2 btn btn-danger" [hidden]="!isButtonShowHide"
              (click)="openModal()">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div class="modal fade" id="deletephoto" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="deletephoto" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <p>Are you sure you want to delete this photo?</p>
          <div class="clearfix"></div>
          <div class="mt-2"><button class="pull-right mb-2 btn btn-primary btncommon delete" (click)="deletePhoto()">
              Delete
            </button>
            <button data-dismiss="modal"
              class="pull-right mb-2 mr-2 btn bg-white text-primary btncancel">Cancel</button>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
